import { useMemo } from "react";
import { useSelector } from "react-redux";
import { USER_TYPES } from "../../screens/Register/components/config";
import { useLocation } from "react-router-dom";
import { getApplication } from "../../services/BaseService";
import { withHiddenApps } from "../../constants/apps";

export function mapUser(user) {
  return {
    ...user,
    company: user.company,
    verified: user.emailVerified,
    companyId: user?.company?.id,
    // {
    //   "admin": {
    //     "role": "",
    //     "status": "approved"
    //   }
    // }
    modules: Array.isArray(user.company?.modules) ?
      user.company?.modules.reduce((all, item) => {
        all[item.id] = item;
        return all;
      }, {}) : user.company?.modules || {},
  };
}

export const createModule = (selectedModule, role = "user") => {
  return {
    [selectedModule]: { status: "approved", role },
  };
}

export const mapModulesFromApps = (user) => {
  const app = getApplication();
  if (user?.company?.apps) {
    const onlyOneApp = withHiddenApps.includes(app);
    user.company.modules = (user?.company?.apps || [])
      .filter((a) => onlyOneApp ? a.access && a.app === app : a.access)
      .reduce((all, app) => {
        const _interface = getInterface({ app, data: app });
        all[_interface] = createModule(
          _interface,
          user?.appps ? (user?.apps[app.app] || {}).role : user.role
        )[_interface];
        return all;
      }, {});
  }
};


export const useApp = () => {
  const location = useLocation();

  const app = useMemo(() => {
    const [, authApp] = location.pathname.split(/^\/(tif|tazama)\/.*$/);
    const [, appApp] = location.pathname.split(/^\/app\/(tif|tazama)\/.*$/);
    const [, dashboardApp] = location.pathname.split(/^\/app\/(tif|tazama)$/);
    const app = authApp || appApp || dashboardApp;

    if (process.env.REACT_APP_APP && app !== 'admin') {
      return process.env.REACT_APP_APP;
    }

    switch (app) {
      case 'tif':
        return 'tif';
      case 'tazama':
        return 'tazama';
      default:
        return 'mmt';
    }
  }, [location]);

  return app;
};

export const useIsTif = () => {
  const { user } = useSelector((state) => state.authentication);

  const isTif = useMemo(() => {
    if (user) {
      const keys = Object.keys(user.modules || {});

      if (keys.includes('tif')) {
        return true;
      }
    }
    return false;
  }, [user])

  return { isTif };
};

export const getTifModule = (user) => {
  if ([USER_TYPES.MINING_PRODUCER, USER_TYPES.BUYER_MINERALS].includes(user?.company?.userType)) {
    return 'cadd';
  }

  return 'pme';
};

export const getSourceName = (source) => {
  return source?.company?.name || source?.stakeholder?.name || source.sourceName || '';
};

export const getModuleFromPathname = (pathname = '') => {
  return pathname.includes('cadd')
    ? 'cadd' : pathname.includes('pme')
      ? 'pme' : 'tif';
}

export const useModule = () => {
  const { pathname } = useLocation();
  const mod = useMemo(() => getModuleFromPathname(pathname), [pathname]);
  return { mod };
};

export const supportedModules = ['cadd', 'pme', 'tif'];

export const getInterface = ({ app, data }) => {
  return data.app === 'mmt' ? app.interface : data.app;
}
